import { Component, OnDestroy, OnInit } from '@angular/core';
import { BootstrapModalService } from 'src/app/core/services/ui/bootstrap-modal.service';
import { TransferUserModalComponent } from '../transfer-user-modal/transfer-user-modal.component';
import { PlayerTransferByCodeModalComponent } from '../player-transfer-by-code-modal/player-transfer-by-code-modal.component';
import {
  PERMITTED_VIEWS,
  USER_TYPE,
} from 'src/app/core/helpers/global/global.constant';
import { GlobalService } from 'src/app/core/services/ui/global.service';
import { TYPES_USER_PERMISSIONS } from 'src/app/core/helpers/global/user-management.constant';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'transfer-selector',
  templateUrl: './transfer-selector.component.html',
})
export class TransferSelectorComponent implements OnInit, OnDestroy {
  public USER_TYPES = USER_TYPE;
  public PERMITTED_VIEWS = PERMITTED_VIEWS;
  public PERMISSION_ROLE = TYPES_USER_PERMISSIONS;
  public currentUserType: string = '';

  private unsubscribe$ = new Subject<void>();

  constructor(
    private modalService: BootstrapModalService<string>,
    private _globalService: GlobalService
  ) { }

  ngOnInit(): void {
    this._globalService.profile
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((profile) => {
        if (profile) {
          this.currentUserType = profile.userType;
        }
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  openModal(selection: string): void {
    this.modalService.openModal({
      component: TransferUserModalComponent,
      data: selection,
    });
  }

  openPlayerByCodeModal(): void {
    this.modalService.openModal({
      component: PlayerTransferByCodeModalComponent,
    });
  }
}
